'use client';
import { jsx } from 'react/jsx-runtime';
import { renderWithRef } from '../core/render-with-ref.js';
import { RenderComp } from '../core/render-comp.component.js';

const PriceBarBanner = renderWithRef('PriceBarBanner', null, (n, a)=>{
    let { children: o } = n;
    return jsx(RenderComp, {
        root: "div",
        forwardedRef: a,
        classNames: new Set([
            'swan-price-bar-banner'
        ]),
        props: n,
        children: o
    });
});

export { PriceBarBanner };
